<template>
  <li class="pb-tag-breadcrumb-item">
    <PbLink
      v-if="link"
      :to="destination"
    >
      {{ tag.name }}
    </PbLink>
    <template v-else>
      {{ tag.name }}
    </template>
  </li>
</template>

<script setup>
import PbLink from '@/components/PbLink.vue'
import useDestination from '@/composables/useDestination'
import { computed } from 'vue'

const props = defineProps({
  tag: { type: Object, required: true },
  link: { type: String, default: '' },
})

const to = computed(() => ({
  name: props.link,
  params: {
    tag: props.tag.pathArr,
  },
}))

const destination = useDestination(to)
</script>
